import { FC, ReactNode } from "react";

interface ICardItem {
  data: {
    title: string;
    description: string;
    icon: ReactNode;
  };
}
const CardItem: FC<ICardItem> = ({ data }) => {
  return (
    <div className="flex gap-2 flex-col">
      <div
        className={
          "bg-[#44B5AE] border-[#A4E1DD] w-20 h-20 rounded-full border-[3px] border-solid flex justify-center items-center"
        }
      >
        {data.icon}
      </div>
      <div className="font-semibold text-lg">{data.title}</div>
      <div>{data.description}</div>
    </div>
  );
};
export default CardItem;
